import { RootState } from '@src/store';
import { IZonesInitialState } from './state';
import { createSelector } from '@reduxjs/toolkit';

const ZonesReducer = (state: RootState): IZonesInitialState => state.ZonesReducer;
const ZonesState = createSelector([ZonesReducer], (state) => state);

export const selectCollapse = createSelector([ZonesState], (state) => state.collapse);

export const selectSelectedZone = createSelector([ZonesState], (state) => {
  return state.selectedZone;
});
export const selectZoneMapLocationUponCreation = createSelector([ZonesState], (state) => state.zoneMapLocationUponCreation);

export const selectFreehandShapeUponCreation = createSelector([ZonesState], (state) => state.freehandShapeUponCreation);

